// Search both the bundled contract and current display copy (including preview).
export function findTranslationReferences({baseline, i18n, query, locations = {}}) {
    const needle = String(query || '').trim().toLowerCase();
    if (!needle) return [];
    const matches = [];
    for (const [namespace, entries] of Object.entries(baseline)) {
        for (const [key, english] of Object.entries(entries)) {
            const reference = `${namespace}:${key}`;
            const published = i18n.t(reference, {lng: 'en', interpolation: {skipOnVariables: true}});
            const display = i18n.t(reference);
            const uses = locations[reference] || [];
            if ([reference, english, published, display, ...uses].some(value => String(value).toLowerCase().includes(needle))) {
                matches.push({reference, english, display, locations: uses});
            }
        }
    }
    return matches.sort((a, b) => {
        const score = row => [row.reference, row.english].some(value => value.toLowerCase() === needle) ? 0 : 1;
        return score(a) - score(b) || a.reference.localeCompare(b.reference);
    });
}
